module.exports = __webpack_public_path__ + "media/icons/search@3x-b6af79f7.svg";